import { _Api } from "../../api/_call";
import { template1 } from "../../../components/common/barcodeTemplate/template1.js";
import { template2 } from "../../../components/common/barcodeTemplate/template2.js";
import { prepareItemsForPrint } from "../../../components/common/barcodeTemplate/printQuantity.js";
import { CustomTemplate } from "components/common/barcodeTemplate/CustomTemplate";
import { getPrintConfig, attachCustomPriceCodes } from "components/common/helpers/barcodeHelper";
import {
  DEFAULT_CUSTOM_TEMPLATE_CONFIG,
  hasCustomTemplateConfig,
  mergeCustomTemplateConfig,
  parseCustomTemplateConfig,
} from "../../../components/common/barcodeTemplate/customTemplateConfig";

const getSelectedDataList = (selectedList, DataList, dataField = "") => {
  let data = [];
  // console.log(selectedList,'getSelectedDataList selectedList')
  // console.log(DataList,'getSelectedDataList DataList')
  if (selectedList.length > 0) {
    selectedList.map(function (v) {
      const filteredDataList = DataList.filter((l) => String(l?.id ?? l?._id ?? "") === String(v?.id ?? v?._id ?? ""));
      if (filteredDataList.length > 0) {
        if (dataField !== "") {
          data.push(filteredDataList[0][dataField])
        } else {
          data.push(filteredDataList[0])

        }
      }
    })
  } else {
    return [];
  }

  return data;
}

const getItemKey = (item) => String(item?.id ?? item?._id ?? item?.stock_id ?? item?.SKU ?? "");

const uniqueItems = (items = []) => {
  const seen = new Set();
  return items.filter((item) => {
    const key = getItemKey(item);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

/** One operation log per stock_id when the user actually prints barcodes. */
export const logBarcodePrint = async (items = [], templateName = "") => {
  if (!Array.isArray(items) || items.length === 0) {
    return;
  }
  try {
    await _Api(
      {
        items: items.map((item) => ({
          stock_id: item?.stock_id ?? "",
          sku: item?.SKU ?? item?.sku ?? "",
        })),
        template_name: templateName || "",
      },
      "api/v1/barcode/print-log"
    );
  } catch (error) {
    console.error("Barcode print log failed", error);
  }
}



// fetchers lets a caller plug in its own request caching (e.g. a component
// that memoizes getByid/get-db-info for as long as it stays mounted, so a
// fresh visit to the page always re-fetches the current saved profile).
// Callers that don't pass them just get a plain uncached request, same as before.
export const exportPdf = async (templateProfileId, selectList, dataList, returnType = "save", options = {}) => {
  const {
    getTemplateProfile = (id) => _Api({ _id: id }, "api/v1/template-printout/getByid"),
    getStoreInfo = () => _Api({}, "api/v1/store-info/get-db-info"),
  } = options;
  let barcode;
  let qrCode;

  if(!templateProfileId){
    return;
  }
  const domain = /:\/\/([^\/]+)/.exec(window.location.href)[1];
  const qrurl = window.location.protocol+"//"+domain+"/v/"

  const selectedDataList = Array.isArray(options.sourceDataList)
    ? options.sourceDataList
    : getSelectedDataList(selectList, dataList);
  const allSelectedDataList = uniqueItems(selectedDataList);
  const stock_id = allSelectedDataList.map((item) => item?.stock_id);
  const product_id = allSelectedDataList.map((item) => item?.product_id);
  const sku = allSelectedDataList.map((item) => item?.SKU);
  const templateProfile = await getTemplateProfile(templateProfileId)


  let docData = []
  let itemPerDocument = 50
  let npage = 1;
  let templateGenaratedData = []
 


  const { data } = await templateProfile;
  const savedCustomTemplateConfig = parseCustomTemplateConfig(
    data?.custom_template_config_info || data?.profile_setup_info?.custom_template_config_info
  );
  const hasSavedCustomTemplateConfig = hasCustomTemplateConfig(savedCustomTemplateConfig);
  const customTemplateConfig = mergeCustomTemplateConfig(
    DEFAULT_CUSTOM_TEMPLATE_CONFIG,
    savedCustomTemplateConfig || {}
  );
  const profileSetupInfo = {
    ...(data?.profile_setup_info || {}),
    ...(hasSavedCustomTemplateConfig
      ? { custom_template_config_info: customTemplateConfig }
      : {}),
  };
  // Keep the latest profile/price-code config while preserving saved custom positions.
  const printConfig = {
    ...getPrintConfig(data),
    ...profileSetupInfo,
  };
  await attachCustomPriceCodes(allSelectedDataList, printConfig, _Api);
  const templateLayout = data?.current_template_layout_selected;
  const templateType = typeof templateLayout === "string" ? templateLayout : templateLayout?.value;
  const renderDataList = Array.isArray(options.renderDataList)
    ? options.renderDataList
    : prepareItemsForPrint(allSelectedDataList);

  // Template 3 generates PRN directly and must not run the PDF/QR preparation path.
  if (templateType === "template_3") {
    return [];
  }

  // Log only on real print (not preview/uri).
  if (returnType === "printout") {
    logBarcodePrint(allSelectedDataList, templateLayout?.label ?? "");
    // logBarcodePrint(allSelectedDataList, data?.config_check_info?.profile_name ?? "");
  }

  if(templateType !== "template_3"){
    if(templateProfileId){


      if (templateProfile.data.profile_setup_info.barcode === true) {
    
        if (templateProfile.data.profile_setup_info.barcode_display == "stock_id") {
    
          barcode = await _Api({ barcodedata: stock_id }, "api/v1/barcode/create")
    
        } else {
          barcode = await _Api({ barcodedata: sku, dataType: "sku" }, "api/v1/barcode/create")
    
        }
      }
    
    
      if (templateProfile.data.profile_setup_info.qr === true) {



        if (templateProfile.data.profile_setup_info.qr_type_display === "offline") {
    
          qrCode = await _Api({ qrCodeData: stock_id, dataList: allSelectedDataList,templateProfile:templateProfile.data.profile_setup_info }, "api/v1/qr-code/createofflinetext")
       
    
        } else if (templateProfile.data.profile_setup_info.qr_type_display === "online") {
          qrCode = await _Api({ url: templateProfile.data.profile_setup_info.qr_url_display }, "api/v1/qr-code/createwebsitelink")
    
        }else if (templateProfile.data.profile_setup_info.qr_type_display === "product_page") {

          const info = await getStoreInfo();
          qrCode = await _Api({ qrCodeData: product_id, dataList: allSelectedDataList,templateProfile:templateProfile.data,website_url:qrurl,info: btoa(info.data)}, "api/v1/qr-code/createproductpagelink")
        }else {
          qrCode = await _Api({ qrCodeData: stock_id, dataList: allSelectedDataList,templateProfile:templateProfile.data.profile_setup_info }, "api/v1/qr-code/createofflinetext")
        }
      }
    
    
    
      // Print the complete selection as one PDF. The preview path can stay
      // paginated, but opening one PDF per 50 items lets the browser print
      // only the first window when multiple print windows are blocked.
      if (returnType === "printout" && data.current_template_layout_selected.value === "template_1") {
        return [await template1(barcode, renderDataList, printConfig, returnType)];
      }

      if (data.current_template_layout_selected.value === "template_1") {
        docData = []
        itemPerDocument = 50
        npage = 1;
        templateGenaratedData = []
             
         for(let page = 0 ; page < Math.ceil(renderDataList.length/itemPerDocument) ; page++){
           let filteredData = []
           docData[page] = []
           let start = (npage - 1) * itemPerDocument;
     
           let end = npage * itemPerDocument;
           for(let i = start ; i < end ; i++){
             
             if(i<renderDataList.length){
               docData[page].push(renderDataList[i])
               filteredData.push(renderDataList[i].stock_id)
     
             }
             
     
             
           }
           let chooseData = stock_id.filter(v => filteredData.includes(v))
            templateGenaratedData.push(await template1(barcode, docData[page], printConfig, returnType))
     
           if(npage===1){
     
             //return template2(barcode, docData[0], qrCode, 'offline', data.profile_setup_info, returnType);
             // template2 = async (barcode, dataList, qrcodedata, qrcode = "offline", config = {}, returnType = "save") => {
     
           }
           npage++
     
         }
     
             //return template1(barcode, allSelectedDataList, data.profile_setup_info, returnType);

             return templateGenaratedData;
      } 
      
      if (returnType === "printout" && data.current_template_layout_selected.value === "template_2") {
        return [await template2(barcode, renderDataList, qrCode, 'offline', printConfig, returnType)];
      }

      if (data.current_template_layout_selected.value === "template_2") {

   docData = []
   itemPerDocument = 50
   npage = 1;
   templateGenaratedData = []
        
    for(let page = 0 ; page < Math.ceil(renderDataList.length/itemPerDocument) ; page++){
      let filteredData = []
      docData[page] = []
      let start = (npage - 1) * itemPerDocument;

      let end = npage * itemPerDocument;


      for(let i = start ; i < end ; i++){
        
        if(i<renderDataList.length){
          docData[page].push(renderDataList[i])
          if(templateProfile.data.profile_setup_info.qr_type_display === "product_page"){
                  filteredData.push(renderDataList[i].product_id)

          }else{
                      filteredData.push(renderDataList[i].stock_id)

          }

        }
        
      }

      let chooseData;
      if(templateProfile.data.profile_setup_info.qr_type_display === "product_page"){
        chooseData = product_id.filter(v => filteredData.includes(v))

      }else{
         chooseData = stock_id.filter(v => filteredData.includes(v))
      }
      

      const pageDataForQr = uniqueItems(docData[page]);

  if (templateProfile.data.profile_setup_info.qr === true) {


        
        if (templateProfile.data.profile_setup_info.qr_type_display === "offline") {

          qrCode = await _Api({ qrCodeData: chooseData, dataList: pageDataForQr,templateProfile:templateProfile.data.profile_setup_info, qr_width: 150 }, "api/v1/qr-code/createofflinetext")


        } else if (templateProfile.data.profile_setup_info.qr_type_display === "online") {
          qrCode = await _Api({ url: templateProfile.data.profile_setup_info.qr_url_display }, "api/v1/qr-code/createwebsitelink")

        }else if (templateProfile.data.profile_setup_info.qr_type_display === "product_page") {

          const info = await getStoreInfo();
          qrCode = await _Api({ qrCodeData: chooseData, dataList: docData[page],templateProfile:templateProfile.data,website_url:qrurl,info: btoa(info.data)}, "api/v1/qr-code/createproductpagelink")
        }else {
          qrCode = await _Api({ qrCodeData: chooseData, dataList: pageDataForQr,templateProfile:templateProfile.data.profile_setup_info, qr_width: 150 }, "api/v1/qr-code/createofflinetext")
        }
      }

      // qrCode = await _Api({ qrCodeData: chooseData, dataList: docData[page],templateProfile:templateProfile.data.profile_setup_info }, "api/v1/qr-code/createofflinetext")

      templateGenaratedData.push(await template2(barcode, docData[npage-1], qrCode, 'offline', printConfig, returnType))

      if(npage===1){

        //return template2(barcode, docData[0], qrCode, 'offline', data.profile_setup_info, returnType);
        // template2 = async (barcode, dataList, qrcodedata, qrcode = "offline", config = {}, returnType = "save") => {

      }
      npage++

    }


        return templateGenaratedData;

      } 



      
      if (data.current_template_layout_selected.value === "custom_template_01") {
    
        docData = []
        itemPerDocument = 50
        npage = 1;
        templateGenaratedData = []
        for(let page = 0 ; page < Math.ceil(allSelectedDataList.length/itemPerDocument) ; page++){
          let filteredData = []
          docData[page] = []
          let start = (npage - 1) * itemPerDocument;
    
          let end = npage * itemPerDocument;
          for(let i = start ; i < end ; i++){
            
            if(i<allSelectedDataList.length){
              docData[page].push(allSelectedDataList[i])
              filteredData.push(allSelectedDataList[i].stock_id)
    
            }

    
            
          }

          let chooseData = stock_id.filter(v => filteredData.includes(v))
           templateGenaratedData.push(await CustomTemplate(
             barcode,
             renderDataList,
             qrCode,
             'offline',
             printConfig,
             returnType,
             hasSavedCustomTemplateConfig ? customTemplateConfig : templateProfile.data.custom_template_config_info
           ))
          
          if(npage===1){
    
            //return template2(barcode, docData[0], qrCode, 'offline', data.profile_setup_info, returnType);
            // template2 = async (barcode, dataList, qrcodedata, qrcode = "offline", config = {}, returnType = "save") => {
    
          }
          npage++
    
        }
        return templateGenaratedData;
        // return CustomTemplate(barcode, allSelectedDataList, qrCode, 'offline', data.profile_setup_info, returnType,templateProfile.data.custom_template_config_info);
    
      } 
      
    
    
    }
    

  }else{
    return false;
  }


}
